
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 341.4 261.65"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{staticClass:"a",attrs:{"y":"220.76","width":"169.01","height":"40.89","rx":"6.18"}}),_c('path',{staticClass:"a",attrs:{"d":"M52.082 122.373l50.77-89.262 85.959 48.891-50.77 89.262zM107.04 27.55l84.4 48a14.74 14.74 0 0014.58-25.62l-84.41-48a14.74 14.74 0 10-14.57 25.62zm226.91 179.11l-157.46-89.55-14.57 25.62 157.48 89.56a14.74 14.74 0 0020.1-5.53 14.75 14.75 0 00-5.55-20.1zM35.01 154.19l84.41 48a14.73 14.73 0 0020.09-5.53 14.73 14.73 0 00-5.52-20.09l-84.41-48a14.74 14.74 0 00-20.1 5.52 14.74 14.74 0 005.53 20.1z"}})])
          )
        }
      }
    